import clsx from "clsx";

export const listingDropdownClassNames = {
  control: (state: { isFocused?: boolean; isDisabled?: boolean }) =>
    clsx(
      "inter min-w-0 flex-grow rounded-2xl border border-white bg-white px-3 py-3 font-semibold transition-all duration-300 hover:border hover:border-grey-border",
      state.isFocused ? "border-grey-border ring-1 ring-grey-border" : "",
      state.isDisabled && "opacity-50",
    ),
  placeholder: () => "!inter !text-primary-foreground text-medium",
};
